module.exports = __webpack_public_path__ + "img/login-v2.deaeca8d.svg";